import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Theme } from '@mui/material';
import {
  getMinimumSearchCharacters,
  getStartsWithContainsFilterOptions,
  SearchMode,
} from 'api/search';
import { SearchFilter } from 'components/SearchFilter/SearchFilter';
import { useTranslation } from 'react-i18next';

const translations = {
  placeholder:
    'ui.event-management.evaluator-links.search-bar.search.placeholder',
  byLabel: 'ui.event-management.evaluator-links.search-bar.search.by-link-name',
  search: 'ui.event-management.evaluator-links.search-bar.search',
  myCreatedLinks:
    'ui.event-management.evaluator-links.filter.show-my-created-links-only',
};

export const EvaluatorLinkListSearchFilter = ({
  searchTerm,
  onSearchTermChange,
  searchMode,
  onSearchModeChange,
  showMyCreatedLinks,
  onShowMyCreatedLinksChange,
}: {
  searchTerm?: string;
  onSearchTermChange: (value: string) => void;
  searchMode: SearchMode;
  onSearchModeChange: (mode: SearchMode) => void;
  showMyCreatedLinks?: boolean;
  onShowMyCreatedLinksChange?: (value: boolean) => void;
}) => {
  const { t } = useTranslation();

  const minSearchCharacterLimit = getMinimumSearchCharacters(searchMode);

  return (
    <SearchFilter<{ leftSelectOptionsType: SearchMode }>
      labelText={`${t(translations.search)} ${t(translations.byLabel)}`}
      placeholder={t(translations.placeholder)}
      showButton={false}
      sx={(theme: Theme) => ({
        marginTop: `${theme.spacing(spacingSizeMap.XS)} !important`,
        padding: `${theme.spacing(spacingSizeMap.S)} !important`,
      })}
      isLabelAboveSearchInput
      inputState={searchTerm}
      handleTermChange={onSearchTermChange}
      minCharacters={minSearchCharacterLimit}
      checkbox={
        onShowMyCreatedLinksChange && {
          checked: !!showMyCreatedLinks,
          label: t(translations.myCreatedLinks),
          onChange: onShowMyCreatedLinksChange,
        }
      }
      leftSelectProps={{
        options: getStartsWithContainsFilterOptions(t),
        onChange: (value: SearchMode) => {
          onSearchModeChange(value);
        },
        value: searchMode,
      }}
    />
  );
};
